import { getLanguage } from "../utils/public";
import zhCN from "./zh-CN";
import zhHK from "./zh-HK";
import enUS from "./en-US";

let language = getLanguage() || 'zh';
let lanFile = null
if (language === 'zh') {
  lanFile = zhCN
} else if (language === 'zh-HK' || language === 'zhhk') {
  lanFile = zhHK
} else if (language === 'en') {
  lanFile = enUS
} else {
  lanFile = zhHK
}

export default {
  ...lanFile
}
